import {
  initialState as noonaInitialState,
  reducer as noonaReducer,
} from './noona/reducer';

import {
  initialState as gtiInitialState,
  reducer as gtiReducer,
} from './gti/reducer';

import {
  initialState as taysPolkuInitialState,
  reducer as taysPolkuReducer,
} from './tayspolku/reducer';

import {
  initialState as libreviewInitialState,
  reducer as libreviewReducer,
} from './libreview/reducer';

import {
  initialState as coxaPolkuInitialState,
  reducer as coxaPolkuReducer,
} from './coxapolku/reducer';

import {
  RECEIVE_SERVICES,
  REQUEST_SERVICES,
  REQUEST_SERVICES_FAILED,
} from './actions';

const serviceNotificationsInitialState = {
  isFetching: false,
  data: [],
  error: null,
};

const serviceIntegrationsInitialState = {
  isFetching: false,
  data: [],
  error: null,
};

const initialState = {
  integrations: serviceIntegrationsInitialState,
  notifications: serviceNotificationsInitialState,
  noona: noonaInitialState,
  gti: gtiInitialState,
  taysPolku: taysPolkuInitialState,
  libreview: libreviewInitialState,
  coxaPolku: coxaPolkuInitialState,
};

export const serviceIntegrationsReducer = (state, action) => {
  switch (action.type) {
    case REQUEST_SERVICES:
      return {
        ...state,
        isFetching: true,
      };
    case RECEIVE_SERVICES:
      return {
        ...state,
        isFetching: false,
        data: action.data,
      };
    case REQUEST_SERVICES_FAILED:
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return {
        ...state,
        integrations: serviceIntegrationsReducer(state.integrations, action),
        noona: noonaReducer(state.noona, action),
        gti: gtiReducer(state.gti, action),
        taysPolku: taysPolkuReducer(state.taysPolku, action),
        libreview: libreviewReducer(state.libreview, action),
        coxaPolku: coxaPolkuReducer(state.coxaPolku, action),
      };
  }
};
